/**
 * Labels and tones for the readable trace timeline.
 *
 * The backend (`view=timeline`) returns each turn as an ordered list of events;
 * this is the only place that knows how those event types look.
 */

export const EVENT_LABEL = {
    input: 'Input',
    model_call: 'Model call',
    tool_call: 'Tool call',
    tool_response: 'Tool response',
    workflow: 'Workflow',
    workflow_step: 'Workflow step',
    decision: 'Decision',
    retrieval: 'Knowledge lookup',
    guard: 'Guardrail',
    note: 'Note',
    error: 'Error',
    response: 'Response',
    turn_end: 'End',
};

const TONES = {
    neutral: 'bg-gray-100 text-gray-700 ring-gray-500/20',
    ok: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    warn: 'bg-amber-50 text-amber-700 ring-amber-600/20',
    danger: 'bg-red-50 text-red-700 ring-red-600/20',
    accent: 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
};

export const toneClass = tone => TONES[tone] || TONES.neutral;

export const STATUS_TONE = { completed: 'ok', paused: 'warn', failed: 'danger' };

export function eventTone(event) {
    const data = event.data || {};
    if (event.type === 'error' || event.status === 'error' || data.error || data.ok === false) return 'danger';
    if (event.type === 'input' || event.type === 'response') return 'accent';
    if (event.type === 'turn_end') return STATUS_TONE[data.status] || 'neutral';
    if (event.type === 'guard') return 'warn';
    return 'neutral';
}

export const OUTCOME_LABEL = {
    answered: 'Answered',
    answered_from_knowledge: 'Answered from knowledge',
    tool_reply: 'Replied with tool result',
    workflow: 'Handled by workflow',
    waiting_for_input: 'Waiting for the user',
    waiting_for_approval: 'Waiting for approval',
    blocked_by_guardrail: 'Blocked by guardrail',
    handed_off: 'Handed off',
    iteration_limit: 'Hit iteration limit',
    time_limit: 'Ran out of time',
    fallback: 'Generic fallback',
    no_reply: 'No reply',
    error: 'Failed',
};

export const outcomeLabel = outcome => OUTCOME_LABEL[outcome] || outcome || '';

export function formatMs(ms) {
    if (ms === null || ms === undefined) return '';
    if (ms < 1000) return `${Math.round(ms)} ms`;
    return `${(ms / 1000).toFixed(1)} s`;
}

export function toText(value) {
    if (value === null || value === undefined) return '';
    return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
}
